import { render } from "./modou.vue?vue&type=template&id=7b2c7a39&scoped=true"
import script from "./modou.vue?vue&type=script&lang=js"
export * from "./modou.vue?vue&type=script&lang=js"

import "./modou.vue?vue&type=style&index=0&id=7b2c7a39&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b2c7a39"

export default script